import { PartnerType } from "../models";
import { VerizonContent } from "./verizon";
import { TelusContent } from "./telus";
import { ATTContent } from "./att";
import { CoxContent } from "./cox";
import { KoodoContent } from "./koodo";
import { USCellularContent } from "./us-cellular";
import { LibertyContent } from "./liberty";

export const PartnerContent = {
  [PartnerType.VERIZON]: VerizonContent,
  [PartnerType.ATT]: ATTContent,
  [PartnerType.TELUS]: TelusContent,
  [PartnerType.KOODO]: KoodoContent,
  [PartnerType.COX]: CoxContent,
  [PartnerType.US_CELLULAR]: USCellularContent,
  [PartnerType.LIBERTY]: LibertyContent,
};
